import { type RefObject, useEffect } from 'react'

type Event = MouseEvent | TouchEvent

export const useOnClickOutside = <T extends HTMLElement = HTMLElement>(
  refs: RefObject<T | null>[],
  handler: (event: Event) => void
) => {
  useEffect(() => {
    const listener = (event: Event) => {
      const doesAnyRefContainEventTarget = refs.some((ref) => {
        const el = ref?.current
        return Boolean(el?.contains?.((event?.target as Node) || null))
      })

      if (!doesAnyRefContainEventTarget) {
        handler(event)
      }
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [refs, handler])
}
